module.exports = __webpack_public_path__ + "research_icon.png?78f1f4072b1abe7e2d0455a7706e27ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-icons/research_icon.png
// module id = 11
// module chunks = 0